import React, { useContext, useEffect, useState } from 'react';
import { StormChaserService } from '../../services/stormChaser/stormChaserService';
import { Marker, Popup, useMap } from 'react-leaflet';
import modalContext from '../../context/modalContext';
import { ModalVideo } from '../modalVideo/modalVideo';
import './stormChaser.css';
import loadingContext from '../../context/loadingContext';
import parameterContext from '../../context/parameterContext';

export const StormChaser = () => {
    const [markers, setMarkers] = useState<any[]>([]);
    const stormChaserService = new StormChaserService();
    const setModal = useContext(modalContext);
    const setLoading = useContext(loadingContext);
    const parameters = useContext(parameterContext);
    const map = useMap();
    let chasers_list = true;
    if (typeof parameters.chasers_list_enabled !== 'undefined') {
        chasers_list = parameters.chasers_list_enabled;
    }
    

    const init = async () => {
        setLoading(true);
        const markers = await stormChaserService.getData();
        setMarkers(markers);
        setLoading(false);

    }
    
    const handleChaserClick = (data: any) => {
        map.setView([data.Latitude, data.Longitude], 8)
    }

    useEffect(() => {
            init();
        
    }, []);
    return (
        <>
            { chasers_list && <div className={ 'chaser-panel' }>
                <h4>Live Chasers</h4>
                <hr className="divider"/>
                <div className={'chasers-content'}>
                    {
                        markers.map((marker, index) => {
                            if (!marker.data.IsStreaming) return null;
                            return (
                                <div key={ index } className={ 'chaser-item' } onClick={()=> handleChaserClick(marker.data)}>
                                    <h5>{ marker.data.User.FirstName + ' ' + marker.data.User.LastName }</h5>
                                    <p>{ `Viewers : ${ stormChaserService.getViewersCount(marker.data) }` }</p>
                                </div>
                            )
                        })
                    }
                    {
                        markers.filter((marker) => marker.data.IsStreaming).length === 0 && (
                            <div className={'no-stream'}>
                                <p>No live streams available!</p>
                            </div>
                        )
                    }
                    
                </div>
            </div>}
            {
                markers.map((marker, index) => {
                    const eventHandlers = {
                        async click() {
                            const data = marker.data;
                            if (data && data.IsStreaming) {
                                setModal({
                                    type: 'Video Stream',
                                    options: {
                                        width: '100%'
                                    },
                                    content: [{
                                        title: '',
                                        description: <ModalVideo data={ data }/>,
                                    }]
                                });
                            }
                        }
                    }

                    return (
                        <Marker
                            key={ index }
                            position={ marker.position }
                            icon={ marker.icon }
                            eventHandlers={ eventHandlers }
                        >
                            {
                                marker.data && !marker.data.IsStreaming && (
                                    <Popup>
                                        <b>{ marker.data.User.UserName }</b>
                                        <br/>
                                        Live Streaming is not available!
                                    </Popup>

                                )
                            }
                        </Marker>
                    )
                })
            }

        </>
    );
}
